module.exports = __webpack_public_path__ + "img/nyul80.07ddf473.jpg";